export class ApiSettings {
    public apiUrl: string;
    public subscriberKey: string;

    public mockOdgService: boolean;
}
